module.exports = __webpack_public_path__ + "media/images/icons/rooms/bed-1p-water-c6f9fe296bba85b7726397db0579193e.svg";